import moment from 'moment';
import { useMeQuery } from '../../useMeQuery';
import { ALL_TEAM } from '../../../../teams/GlobalTeamsSelector';
import { usePolicies } from './usePolicies';
import type { POLICY_STATUS } from '../../../../console/_statics/policy.statics';

export function useCheckAnyPolicyHasStatus(status: POLICY_STATUS) {
  const { data: me } = useMeQuery();

  const accountId = me?.account?.id;

  const filter = {
    search: accountId,
    orderBy: 'timestamp',
    order: 'desc',
    size: 50,
    before: moment().endOf('day').unix(),
    after: moment('01-01-2020').unix(),
    teamIds: [ALL_TEAM.id],
  };

  const { data } = usePolicies(filter);

  if (!Array.isArray(data?.policies)) {
    return false;
  }

  return data?.policies.some((policy) => policy.status === status);
}
